module.exports = __webpack_public_path__ + "static/media/illust02.97c01786.png";